{
  "shellWaitLabel": "로드 중"
}
